import React from 'react';

import { WebinarPlayerUIState } from '$/components/WebinarPlayer/context';

interface VideoStageAreaStyle {
  x: string;
  y: string;
  width: number;
  height: number;
  scale: number;
  borderRadius: string;
  opacity?: number;
}
export const useVideoStageArea = (
  props: Pick<
    WebinarPlayerUIState,
    'currentRoom' | 'dimensions' | 'animations' | 'pinnedInteraction'
  >
): [VideoStageAreaStyle, VideoStageAreaStyle | undefined] => {
  const { currentRoom, dimensions, pinnedInteraction } = props;
  const [style, animateStyle] = React.useMemo(() => {
    const yPx = Math.round(
      dimensions.videoControlsArea.topBar.height +
        (dimensions.videoArea.height - dimensions.videoStage.unscaled.height) / 2
    );
    const xPx = Math.round((dimensions.roomArea.width - dimensions.videoStage.unscaled.width) / 2);
    const style = {
      x: `${xPx}px`,
      y: currentRoom.caps.hideVideoPlayerStage ? '-100vh' : `${yPx}px`,
      width: dimensions.videoStage.width,
      height: dimensions.videoStage.height,
      scale: 1 / dimensions.videoStage.scale,
      borderRadius: `${dimensions.videoStage.radius}px`,
    };

    let borderRadius = style.borderRadius;
    if (pinnedInteraction) {
      borderRadius = `0 0 ${style.borderRadius} ${style.borderRadius}`;
    }

    return [
      style,
      dimensions.isMeasured
        ? {
            ...style,
            opacity: currentRoom.caps.hideVideoPlayerStage ? 0 : 1,
            borderRadius,
          }
        : undefined,
    ];
  }, [
    dimensions.isMeasured,
    dimensions.roomArea.width,
    dimensions.videoArea.height,
    dimensions.videoStage.width,
    dimensions.videoStage.height,
    dimensions.videoStage.scale,
    dimensions.videoStage.radius,
    dimensions.videoStage.unscaled.height,
    dimensions.videoStage.unscaled.width,
    currentRoom.caps.hideVideoPlayerStage,
    dimensions.videoControlsArea.topBar.height,
    pinnedInteraction,
  ]);
  return [style, animateStyle];
};
